const freischaltcode = document.getElementById('freischaltcode');

if (freischaltcode) {
    var freischaltcodeTimer;

    freischaltcode.addEventListener('click', function () {
        navigator.clipboard.writeText(freischaltcode.querySelector('code').innerText);

        freischaltcode.classList.add('success');

        if (freischaltcodeTimer) {
            window.clearTimeout(freischaltcodeTimer);
        }

        freischaltcodeTimer = window.setTimeout(function () {
            freischaltcode.classList.remove('success');
        }, 2000);
    });
}